import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import { InfoBannerProps } from "./types";

const InfoBanner = ({ title }: InfoBannerProps) => {
    return (
        <BannerView
            bannerType={BannerType.Warning}
            title={title}
            css={css({
                marginTop: "16px"
            })}
        />
    );
};

export default InfoBanner;
